export default {
  name: 'RtTableColumn',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  render(h) {
    const options = {
      attrs: this.$attrs,
      props: {
        className: this.fixed
          ? `rt-fixed-column rt-fixed-column-${this.className}`
          : ''
      }
    };
    if (this.$scopedSlots.default) {
      options.scopedSlots = {
        default: props =>
          this.$scopedSlots.default({
            row: props.row,
            $index: props.$index
          })
      };
    }
    return h('el-table-column', options, this.$slots.default);
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/table/rtTableColumn.js